module.exports = __webpack_public_path__ + "static/media/botao-digitalizar.fa5983c6.png";